import {
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Modal as ModalChakra,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { classNames } from '../../utils/common';

const Modal = ({ isOpen, onClose, children, contentBg, bodyClassname, ...rest }) => {
  return (
    <ModalChakra isOpen={isOpen} onClose={onClose} isCentered {...rest}>
      <ModalOverlay
        bg='blackAlpha.300'
        backdropFilter='blur(10px) hue-rotate(90deg)'
      />
      <ModalContent rounded="3xl" bg={contentBg}>
        <ModalCloseButton />

        <ModalBody
          p="8"
          className={classNames(bodyClassname, "flex flex-col gap-4 2xl:gap-7 text-gray-700")}
        >
          {children}
        </ModalBody>
      </ModalContent>
    </ModalChakra>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  contentBg: PropTypes.string,
  bodyClassname: PropTypes.string,
  rest: PropTypes.object,
};

export default Modal;
